import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getEnvio, recibirEnvioArticulo } from "../../../project/services/EnvioArticuloService";
import RecepcionArticuloDialog from "./RecepcionArticuloDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialEnvioArticulo = {
  codigoEnvio: "",
  areaOrigen: "",
  fechaRegistracion: "",
  observaciones: "",
};

const nameItemsText = "Recepción de artículos";
//
// ###########################################################################
//
const RecepcionArticulo = () => {
  const navigate = useNavigate();
  const params = useParams();
  const idEnvioArticulo = params.idEnvio;
  const action = params.action;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [envioArticuloData, setEnvioArticuloData] = useState(initialEnvioArticulo);
  const [envioArticuloItems, setEnvioArticuloItems] = useState([]);
  const [envioArticuloEstadoRows, setEnvioArticuloEstadoRows] = useState([]);
  const [envioArticuloItem, setEnvioArticuloItem] = useState({});
  const [openEnvioArticuloDialog, setOpenEnvioArticuloDialog] = useState(false);
  const [actionTitle, setActionTitle] = useState("");
  //
  // ##########################################################################
  //
  const tableColumns = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      width: 150,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descripcion_articulo",
      headerName: "Descripción",
      flex: 1,
      minWidth: 350,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo + " " + params.row.modelo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.cantidad}</span>
      ),
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Ver Artículo">
          <IconButton
            size="small"
            aria-label="view"
            onClick={() => handleClickActionCrud(params.row, "view")}
          >
            <RemoveRedEyeOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      maxWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        switch (_val) {
          case 'pendiente-recibir':
            _val = "PENDIENTE DE RECIBIR";
            break;
          case 'recibido':
            _val = "RECIBIDO";
            break;
          case 'anulado':
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "usuario",
      headerName: "Vendedor/Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "motivo",
      headerName: "Motivo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {

    if (action === "view") {
      setActionTitle("Ver");
    } else if (action === "receive") {
      setActionTitle("Recibir");
    }

    load();
  }, []);
  //
  // ##########################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getEnvio(idEnvioArticulo);
    setIsDoingSomething(false);

    if (response.ok) {

      const _envioArticuloData = response.data.data;

      setEnvioArticuloData({
        ...envioArticuloData,
        codigoEnvio: _envioArticuloData.codigo,
        areaOrigen: _envioArticuloData.descripcion_area_origen,
        fechaRegistracion: _envioArticuloData.fecha_creacion,
        observaciones: _envioArticuloData.observaciones,
      });

      setEnvioArticuloItems(response.data.data.envio_articulo_list);

      const _envio_estado_list = _envioArticuloData.envio_estado_list;
      setEnvioArticuloEstadoRows(_envio_estado_list);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/recepcion-articulo-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setEnvioArticuloData({
      ...envioArticuloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleCloseArticuloDialog = () => {
    setOpenEnvioArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleClickActionCrud = async (parEnvioArticuloItem) => {
    setEnvioArticuloItem(parEnvioArticuloItem);
    setOpenEnvioArticuloDialog(true);
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    let _envioArticuloObject = {
      id: idEnvioArticulo,
    };
    setIsDoingSomething(true);
    const response = await recibirEnvioArticulo(_envioArticuloObject);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        handleCancelar();
      }, 1000);
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {actionTitle} {nameItemsText} {envioArticuloData.codigoEnvio}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                id="areaOrigen"
                label="Area de Origen"
                variant="outlined"
                size="small"
                name="areaOrigen"
                value={envioArticuloData.areaOrigen}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                  maxLength: 3,
                }}
                id="fechaRegistracion"
                label="Fecha de Registración"
                variant="outlined"
                size="small"
                name="fechaRegistracion"
                value={envioArticuloData.fechaRegistracion}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 1 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Artículos recibidos
                </Typography>
                <DataGrid
                  rows={envioArticuloItems}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={envioArticuloData.observaciones ? envioArticuloData.observaciones.toLocaleUpperCase() : ""}
                onChange={handleChange}
                disabled={action === "view" || action === "delete"}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                    minWidth: "400px",
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Estados de la Recepción de Artículos
                </Typography>
                <DataGrid
                  rows={envioArticuloEstadoRows}
                  columns={tableColumnsEstado}
                  {...tableOptions}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {(action === "receive") && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={save}
                  startIcon={<FileDownloadDoneIcon />}
                >
                  Recibir
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelar}
              >
                Cerrar
              </Button>
            </Box>

          </Grid>
        </Grid>
      </Paper >

      {openEnvioArticuloDialog && (
        <RecepcionArticuloDialog
          envioArticuloItem={envioArticuloItem}
          onClose={handleCloseArticuloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {/* >>>> Messages */}

      {
        showMessage && (
          <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
        )
      }

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default RecepcionArticulo;